export default "__VITE_ASSET__BzZZivQm__"